<template>
    <tr>
        <template v-for="(columnIndex, index) in columnLength">
            <td scope="col"
                v-if="getActiveLabel(columnIndex)"
                :colspan="getActiveLabel(columnIndex).columns.colspan"
                :class="[getClasses(columnIndex), {'scroller-fixed-column': index == 0}]"
                class="font-bold">
                    {{ getActiveLabel(columnIndex).label }}
            </td>
            <td scope="col"
                v-else
                :class="{'scroller-fixed-column': index == 0}">
                    &nbsp;
            </td>
        </template>
    </tr>
</template>

<script setup>
import { computed } from 'vue';

// Props
const props = defineProps({
    columns: Array,
    labels: Array,
    header: Boolean,
    footer: Boolean
});

// Computed values
const columnLength = computed(() => {
    const colSpanCount = props.labels.map((mLabel) => mLabel.columns.colspan)
        .reduce((acc, number) => acc + number, 0);
    return props.columns.length - colSpanCount + props.labels.length;
});

// Methods
const getActiveLabel = (columnIndex) => {
    return props.labels.find((mLabel) => {
        return mLabel.columns.startIndex === columnIndex;
    });
};

const getClasses = (columnIndex) => {
    const classes = getActiveLabel(columnIndex).classes;

    if (props.header) {
        return [...classes, 'border-b-2'];
    } else {
        return [...classes, 'border-t-2'];
    }
};
</script>
